var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-stepper',_vm._g(_vm._b({class:[_vm._.stepper, _vm.readOnly && _vm._.readOnly]},'van-stepper',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }